import CardBrandHeader from './CardBrandHeader';

// The product card, shared by the Collection and Discover tabs.
//
// Everything a card has in common lives here — the brand strip, the image well
// with its "No image" fallback, the frame and the title. What differs is passed
// as children and rendered inside .collection-card-body beneath the title: an
// owned piece shows its documents and QR, an unowned one its price and spec.
//
// Extracted rather than copied so the two cannot drift. A piece a user does not
// own should look exactly like one they do — that similarity is the point, and
// two implementations would not hold it for long.
//
// `p` needs: product_id, name, image_url, plus whatever CardBrandHeader reads.
// `overlay` is an optional control pinned to the card's own corner — it sits
// outside .collection-card-body deliberately, so it floats over the brand strip
// instead of taking a line in the content.
const ProductCard = ({ p, children, overlay }) => (
    <div className="collection-card">
        {overlay}
        <CardBrandHeader p={p} />
        {/* startsWith('http') because a presigned S3 URL and a plain URL both
            qualify, while a stray S3 URI or empty string does not — those get
            the placeholder instead of a broken image. */}
        {p.image_url && p.image_url.startsWith('http')
            ? <img className="collection-card-img" src={p.image_url} alt={p.name} loading="lazy" />
            : <div className="collection-card-img collection-card-img--empty">No image</div>}

        <div className="collection-card-body">
            <div className="collection-card-title">{p.name}</div>
            {children}
        </div>
    </div>
);

export default ProductCard;
